module.exports = __webpack_public_path__ + "static/dwarf_with_tentacle_whip-11e818b3b3cac34fe8d8f4ec3e1b10f0.png";